
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutOS7HpsGFDFSTbbd4iXDP92Iuvckam0GQw5dgZEXCgBIMeta } from "/vercel/path0/pages/about.vue?macro=true";
import { default as indexG_WfXOzFIdmY7nC2wskK9_5LGE8hGwIJyZEyCaXLOuMMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as createBxmMhHonEgMOM40RouwHUpt50ldzE9mGfcUED8syFlAMeta } from "/vercel/path0/pages/create.vue?macro=true";
import { default as librarySKluPz0t9d19OZHyQKRZgZR9KK8PH6XYkwbA16GIpFUMeta } from "/vercel/path0/pages/library.vue?macro=true";
import { default as m_45createUhJ_45ny2eIedaVTQe50rT14naFAtwRI_45WUZ0a2k9tsaIMeta } from "/vercel/path0/pages/m-create.vue?macro=true";
import { default as indexh1r4MDZ8gLTn2Qc0f_45_Bw1TZFYETuSG5ptBBpcS_zjkMeta } from "/vercel/path0/pages/music/index.vue?macro=true";
import { default as search9RSb2U8sgl_4p6viAyodj7YtKHLoYeLGY7CaKJOQ2R4Meta } from "/vercel/path0/pages/music/search.vue?macro=true";
import { default as mv_45generator04GwU6_45lFMzqqawcOfg5CSoR7soza0UEeiWypq44KngMeta } from "/vercel/path0/pages/mv-generator.vue?macro=true";
import { default as _91id_930wzMQp7IbTwCu4AYFroGnWFn_45C3y_4550YwlGJ1HYMvqIMeta } from "/vercel/path0/pages/payment/[id].vue?macro=true";
import { default as subscriptiondjadAkOwlmKbjZC26GDVpK0JHeeA5UpR4koRzKsS8roMeta } from "/vercel/path0/pages/subscription.vue?macro=true";
import { default as _91token_93pm4h91L6mz58EO96a12q7C074WfObbz6VQZmgjt4g4wMeta } from "/vercel/path0/pages/share/[token].vue?macro=true";
import { default as _91section_93GyQDbjJ8u7NhIHVuFAPQFD6PVMXxZl1i8iDddFIahpMMeta } from "/vercel/path0/pages/music/[section].vue?macro=true";
import { default as _91id_93uElFIrI_P6JJrWDXpKXAlemYwIX37fR7y8InO99D_WoMeta } from "/vercel/path0/pages/music/song/[id].vue?macro=true";
import { default as lyrics_45generatorp16_45_45YPvVLWgxZHplyG9tt1pWuP5VZ8f_sToUi3c9scMeta } from "/vercel/path0/pages/lyrics-generator.vue?macro=true";
import { default as vocal_45separationbDa7daNLNURCBE6CHmQCVC40izU1u4h0FGk6mifbF3wMeta } from "/vercel/path0/pages/vocal-separation.vue?macro=true";
import { default as rap_45name_45generatoruopW776_fw4XT_uVa1g20Vhr3_45hhw5C7BhTdfOQBY0oMeta } from "/vercel/path0/pages/rap-name-generator.vue?macro=true";
import { default as rap_45lyrics_45generatoroBYPC8M3QbSlULHA3TRSOK7gakeUEqVBEmxZw0F4gZcMeta } from "/vercel/path0/pages/rap-lyrics-generator.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    component: () => import("/vercel/path0/pages/about.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/vercel/path0/pages/create.vue")
  },
  {
    name: "library",
    path: "/library",
    component: () => import("/vercel/path0/pages/library.vue")
  },
  {
    name: "m-create",
    path: "/m-create",
    component: () => import("/vercel/path0/pages/m-create.vue")
  },
  {
    name: "music",
    path: "/music",
    component: () => import("/vercel/path0/pages/music/index.vue")
  },
  {
    name: "music-search",
    path: "/music/search",
    component: () => import("/vercel/path0/pages/music/search.vue")
  },
  {
    name: "mv-generator",
    path: "/mv-generator",
    component: () => import("/vercel/path0/pages/mv-generator.vue")
  },
  {
    name: "payment-id",
    path: "/payment/:id()",
    component: () => import("/vercel/path0/pages/payment/[id].vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    component: () => import("/vercel/path0/pages/subscription.vue")
  },
  {
    name: "share-token",
    path: "/share/:token()",
    meta: { ...(_91token_93pm4h91L6mz58EO96a12q7C074WfObbz6VQZmgjt4g4wMeta || {}), ...{"middleware":[]} },
    component: () => import("/vercel/path0/pages/share/[token].vue")
  },
  {
    name: "music-section",
    path: "/music/:section()",
    component: () => import("/vercel/path0/pages/music/[section].vue")
  },
  {
    name: "music-song-id",
    path: "/music/song/:id()",
    component: () => import("/vercel/path0/pages/music/song/[id].vue")
  },
  {
    name: "lyrics-generator",
    path: "/lyrics-generator",
    component: () => import("/vercel/path0/pages/lyrics-generator.vue")
  },
  {
    name: "vocal-separation",
    path: "/vocal-separation",
    component: () => import("/vercel/path0/pages/vocal-separation.vue")
  },
  {
    name: "rap-name-generator",
    path: "/rap-name-generator",
    component: () => import("/vercel/path0/pages/rap-name-generator.vue")
  },
  {
    name: "rap-lyrics-generator",
    path: "/rap-lyrics-generator",
    component: () => import("/vercel/path0/pages/rap-lyrics-generator.vue")
  }
]